import { Modal } from "react-bootstrap";
import { Contest } from "interfaces/leaderboard/contest";
import styles from "./styles.module.css";
import { sparketBlack } from "utils/constants.ts";
import BlockyBoldText from "components/custom-texts/blocky-bold-text.tsx";
import { useAppSelector } from "state/hooks.ts";
import BalanceDisplay from "components/common/real-money-wallet/balance-display.tsx";
import { ContestItem } from "components/contests/contest-display-items";
import ContestModalEnterContestButton from "components/contests/contest-modal/contest-modal-enter-contest-button.tsx";
import { getEntriesByContestId } from "state/slices/contests-slice.ts";
import { checkIfUserCanEnterContest } from "utils/contestEntryUtils";
import { getIntegratedAppState, IntegratedAppState } from "state/slices/integrated-app-slice.ts";

interface Props {
  contest: Contest;
  show: boolean;
  setShow: (show: boolean) => void;
}

const ContestModal = ({ contest, show, setShow }: Props) => {

  const userContestEntries = useAppSelector((state) => getEntriesByContestId(state, contest.id)) || [];

  const integratedAppSlice = useAppSelector(getIntegratedAppState);

  const canEnterContest = checkIfUserCanEnterContest(contest, userContestEntries);

  return (
    <Modal show={show} onHide={() => setShow(false)}>

      <Modal.Header style={{ backgroundColor: sparketBlack }} closeVariant={"white"} closeButton>
        <BlockyBoldText
          style={{ color: "white", marginLeft: 10 }}
        >
          Contest Details
        </BlockyBoldText>
      </Modal.Header>
      <div className={styles.modal}>
        <div className={styles.body}>

          {integratedAppSlice.state === IntegratedAppState.NOT_INTEGRATED && <BalanceDisplay />}


          <ContestItem contest={contest} showStatus
                       userContestEntries={userContestEntries} />

          {canEnterContest && <ContestModalEnterContestButton contest={contest} setShowModal={setShow} />}
        </div>
      </div>
    </Modal>
  );
};

export default ContestModal;